import React, { useState } from 'react';
import { publish } from '@wh/message-bus';
import './ActionArea.scss';

import { SearchIcon } from './SearchIcon';
import { CloseIcon } from './CloseIcon';
import { LoginButton } from './buttons/Login';
import { RegistrationButton } from './buttons/Registration';
import { DepositButton } from './buttons/Deposit';
import { depositLinkClicked, useMessageBusSubscribe } from '../messagebus';
import DepositLinkIcon from './DepositLinkIcon';


export const ActionArea = ({ content, buildVertical, buttonVisibility }) => {

  const {
    depositLinkButtonVisible,
    loginButtonVisible,
    registrationButtonVisible,
    depositButtonVisible
  } = buttonVisibility;

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  useMessageBusSubscribe('search.open', () => { setIsSearchOpen(true); });
  useMessageBusSubscribe('search.close', () => { setIsSearchOpen(false); });

  const searchClicked = () => {
    if (buildVertical?.startsWith('sportsbook')) {
      if (isSearchOpen) {
        publish('search.close');
      } else {
        publish('search.open');
      }
    } else {
      publish('wh.common.event.ui.header.search.clicked');
    }
  }

  const showSearch = buildVertical === 'gaming' 
    || buildVertical === 'casino' 
    || buildVertical?.startsWith('sportsbook');

  return <div className="sb-header__section sb-header__section--align-right" data-test-id="header.slot-actions">
      {loginButtonVisible && <LoginButton label={content?.['login-button']}/>}
      {registrationButtonVisible && <RegistrationButton label={content?.['registration-button']} />}
      {depositLinkButtonVisible && <div className="sb-header__item">
        <button className='sb-header-deposit-link' onClick={depositLinkClicked}>
          <DepositLinkIcon />
        </button>
      </div>}
      {depositButtonVisible && <DepositButton label={content?.['deposit-button']} />}
      <div className="sb-header__item">
        <div id='cp-ma-wrapper'></div>
      </div>
      {showSearch && <div className="sb-header__item">
        <button className='sb-header-search' onClick={searchClicked}>
          {isSearchOpen ? <CloseIcon /> : <SearchIcon />}
        </button>
      </div>}
    </div>;
}
